import React, { useEffect, createRef } from "react";
import ImageWorkflowMobile from "../../images/workflow-mobile.png";
import ImageWorkflowChart from "../../images/workflow-chart.png";
//import AOS from 'aos';
import 'aos/dist/aos.css'
import lottie from 'lottie-web';
import animation from '../../icons/svg_animations/Patients-Workflow/Patients-Workflow.json';
import InView from 'react-intersection-observer';

export default function Intro() {
    let AOS;
    let animationContainer = createRef();

    useEffect(() => {
      const AOS = require("aos");
      AOS.init({
        once: true,
      });
      
    }, []);
  
    useEffect(() => {
      if (AOS) {
        AOS.refresh();
      }
    });
  return (
      <div className="section-gap-large po-cs-workflow-section">
          <div className="container">
            <div className="workflow-inner row d-flex flex-wrap align-start">
                <div className="col left-image-workflow">
                    <div data-aos="zoom-in-right" data-aos-delay="300"><img src={ImageWorkflowMobile} title="personalized patient experience" alt="personalized patient experience" /></div>
                </div>
                <div className="col right-image-workflow">
                  <InView as="div" onChange={(inView) => {
                      if (inView && animation)
                        lottie.loadAnimation({
                          container: animationContainer.current,
                          renderer: "svg",
                          loop: false,
                          autoplay: true,
                          animationData: animation
                        });
                    }} triggerOnce={true}>
                    <div className="workflow-animation-container" ref={animationContainer} />
                  </InView>
                </div>
            </div>
          </div>
      </div>
  );
}